import { AnyAction } from 'redux'
import { createAction } from 'redux-actions'
import { ThunkDispatch } from 'redux-thunk'
import { message } from 'antd'
import { RootState } from '../../reducers'
import { post, url } from '../../../javascripts/http'
import { actionGetSilizhuMenuAndOrg, actionLogoutSuccess } from '../user'
import { AccountType, isHasBasicInfo, verifyTelcodeOrEmail } from '../../../javascripts/generic'
import { InstitutionService } from '../../../api/sennotech/scanner/v2/institution'
import { AccountService } from '../../../api/sennotech/scanner/v2/account'
import { ObjectStorageService } from '../../../api/sennotech/scanner/v2/object_storage'
import { StoreService } from '../../../api/sennotech/scanner/v2/store'


var COS = require('cos-js-sdk-v5');

const accountService = new AccountService(url, post);
const institutionService = new InstitutionService(url, post);
const objectStorageService = new ObjectStorageService(url, post)
const storeService = new StoreService(url, post);

//获取管理员
export function actionGetAdminInfo() {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        message.loading("加载中...", 0)
        try {
            
            let id = getState().user.orgId;
            let res = await accountService.listAccounts({
                organizationId: +id
            })
            
            dispatch(actionGetAdminInfoSuccess({
                data: res.accounts
            }))
            message.destroy();
        } catch(error) {
            message.destroy();
            console.log(error);
        }
       
    }
}

export const ACTION_GETADMININFO_SUCCESS = 'SILIZHU.ACTION_GETADMININFO_SUCCESS';

export interface ActionGetAdminInfoSuccessPayload {
    data: any,
}

const actionGetAdminInfoSuccess = createAction(
    ACTION_GETADMININFO_SUCCESS,
    (payload: ActionGetAdminInfoSuccessPayload) => {
        return payload
    }
);

//添加管理员
export function actionAddAdmin (data, isStaff?) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        try {

            let reg = verifyTelcodeOrEmail(data.accountName);
            if(!reg.vaild) return;

            message.loading("添加中...", 0);

            let orgId = getState().user.orgId;
            if(reg.type === AccountType.MOBILENUMBER) {
                await accountService.createAccount({
                    organizationId: +orgId,
                    role: isStaff ? "staff": "admin",
                    name: data.name,
                    countryCode: "86",
                    mobileNumber: data.accountName,
                })
            }
            else if(reg.type === AccountType.EMAIL) {
                await accountService.createAccount({
                    organizationId: +orgId,
                    role: isStaff ? "staff": "admin",
                    name: data.name,
                    email: data.accountName,
                })
            }
            

            dispatch(actionAddAdminSuccess({
                data: {}
            }))

            message.destroy();
            message.success('添加成功', 6);
            dispatch(actionGetAdminInfo())

        } catch(error) {
            message.destroy();
            console.log(error);
        }
    }
}

export const ACTION_ADDADMIN_SUCCESS = 'SILIZHU.ACTION_ADDADMIN_SUCCESS';

export interface ActionAddAdminSuccessPayload {
    data: any
}

const actionAddAdminSuccess = createAction(
    ACTION_ADDADMIN_SUCCESS,
    (payload: ActionAddAdminSuccessPayload) => {
        return payload
    }
);

//删除管理员
export function actionDeleteAdmin (accountId) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        try {
            
            message.loading("删除中...", 0)
            let orgId = getState().user.orgId;
            await accountService.deleteAccount({
                organizationId: +orgId,
                accountId: accountId
            })

            dispatch(actionDeleteAdminSuccess({
                data: {}
            }))

            message.destroy();
            message.success('删除成功', 6);
            dispatch(actionGetAdminInfo());

        } catch(error) {
            message.destroy();
            message.error('删除失败', 8);
            console.log(error);
        }
    }
}

export const ACTION_DELETEADMIN_SUCCESS = 'SILIZHU.ACTION_DELETEADMIN_SUCCESS';

export interface ActionDeleteAdminSuccessPayload {
    data: any
}

const actionDeleteAdminSuccess = createAction(
    ACTION_DELETEADMIN_SUCCESS,
    (payload: ActionDeleteAdminSuccessPayload) => {
        return payload
    }
);


async function uploadCos(file) {
    let type = file.type.split('/')[1];
    let time = new Date().getTime();
    let filename = `orgLogo-${time}.${type}`;
    let res = await objectStorageService.listKeyPrefixes({});
    let prefix = res.prefixes.find((item) => {
        return item.name === "ORGANIZATION_LOGO"
    }) || {};
    if(!prefix.hasOwnProperty("name")) return;
    let res_cos = await objectStorageService.getCosStsCredential({
        prefix
    } as any)

    let expireTime = (new Date(res_cos.expireTime as any)).valueOf();
    let expirationTime = +(expireTime || 0) / 1000;
    var cos = new COS({
        getAuthorization: function(options, callback) {
            callback({
                TmpSecretId: res_cos.tmpSecretId,
                TmpSecretKey: res_cos.tmpSecretKey,
                XCosSecurityToken: res_cos.sessionToken,
                ExpiredTime: expirationTime, // 时
            });
        }
    });

    return new Promise((resolve, reject) => {
        cos.putObject({
            Bucket: res_cos.bucket,
            Region: res_cos.region,
            Key: res_cos.keyPrefix + filename,
            Body: file,
            onProgress: function (info) {
                let progress = JSON.stringify(info);
                console.log({ progress })
            }
        }, function(err, data) {

            console.log({data, err});
            if(err) {
                reject(err)
            }
            else {
                let filePath = `https://${data.Location}`
                resolve(filePath)
            }
        })
    })
}

// 更新机构信息
export function actionUpdateInstitution (data, file) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        try {

            message.loading("修改中...", 0);
            if(file) {
                let url = await uploadCos(file);
                data.logo = url;
            }
            await institutionService.updateInstitution(data);

            dispatch(actionUpdateInstitutionSuccess({
                data: {}
            }))

            message.destroy();
            message.success('修改成功', 6);
            dispatch(actionGetSilizhuMenuAndOrg())

        } catch(error) {
            message.destroy();
            console.log(error);
        }
    }
}

export const ACTION_UPDATEINSTITUTION_SUCCESS = 'USER.ACTION_UPDATEINSTITUTION_SUCCESS';

export interface ActionUpdateInstitutionSuccessPayload {
    data: any
}

const actionUpdateInstitutionSuccess = createAction(
    ACTION_UPDATEINSTITUTION_SUCCESS,
    (payload: ActionUpdateInstitutionSuccessPayload) => {
        return payload
    }
);


//更新店铺信息
export function actionUpdateStore (data, file) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        try {

            message.loading("修改中...", 0);
            if(file) {
                let url = await uploadCos(file);
                data.logo = url;
            }
            await storeService.updateStore(data)

            dispatch(actionUpdateStoreSuccess({
                data: {}
            }))

            message.destroy();
            message.success('修改成功', 6);
            dispatch(actionGetSilizhuMenuAndOrg())

        } catch(error) {
            message.destroy();
            console.log(error);
        }
    }
}

export const ACTION_UPDATESTORE_SUCCESS = 'USER.ACTION_UPDATESTORE_SUCCESS';

export interface ActionUpdateStoreSuccessPayload {
    data: any
}

const actionUpdateStoreSuccess = createAction(
    ACTION_UPDATESTORE_SUCCESS,
    (payload: ActionUpdateStoreSuccessPayload) => {
        return payload
    }
);